import React from "react";
import Card from "../../components/Card/Card";
import * as Yup from "yup";
import { Formik } from "formik";
import Typography from "@material-ui/core/Typography/Typography";
import {
  FormControl,
  Input,
  InputLabel,
  FormHelperText,
  Button,
} from "@material-ui/core";
import { connect } from "react-redux";
import {Auth} from "aws-amplify";
import axios from "axios";
import { toast } from "react-toastify";
import { loginAction } from "../../Redux/Actions/Authentication";
import { primaryColor } from "../../assets/jss/material-dashboard-react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import {checkAdmin} from "../../Redux/sagas/users/Api"

const isLocalAuth = process.env.REACT_APP_LOCAL_AUTH === 'true';
const theme = createMuiTheme({
  palette: {
    primary: {
      main: primaryColor[0],
    },
  },
});
const styles = {
  cardStyles: {
    width: "40%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "50px",
    padding: "20px",
  },
};

const validationSchema = Yup.object().shape({
  password: Yup.string()
    .required("Enter Password")
    .min(6, "Password must be 6 characters long"),
  email: Yup.string().required("Enter Email").email("Enter Correct Email"),
});

class SignIn extends React.Component {
  submitHandler = async (values) => {
    try {
      if (isLocalAuth) {
        // Local mode: call backend login directly
        await checkAdmin({email: values.email});
        const res = await axios.post(`${process.env.REACT_APP_APIURL}/user/login`, {
          email: values.email,
          password: values.password,
        });
        const backendUser = res.data.user;
        // Build a Cognito-compatible user object for the saga
        const localUser = {
          attributes: {
            email: backendUser.email,
            given_name: backendUser.firstName,
            family_name: backendUser.lastName,
            sub: backendUser._id,
          },
        };
        const { dispatch } = this.props;
        dispatch(loginAction(localUser, { email: values.email, password: values.password, token: res.data.token }));
      } else {
        // Production mode: use Cognito Auth
        await checkAdmin({email: values.email});
        const user = await Auth.signIn(values.email, values.password);
        const session = await Auth.currentSession();
        const idToken = session?.getIdToken?.().getJwtToken?.();
        const { dispatch } = this.props;
        dispatch(loginAction(user, { email: values.email, password: values.password, idToken }));
      }
    } catch (error) {
      toast.error(error?.response?.data?.error||"There was an error signing in to your account. Please try again later.");
    }
  };
  render() {
    return (
      <ThemeProvider theme={theme}>
        <div>
          <Card style={styles.cardStyles}>
            <Typography
              variant="h3"
              color="primary"
              style={{ textAlign: "center" }}
            >
              Viideon
            </Typography>
            <Formik
              onSubmit={this.submitHandler}
              initialValues={{
                password: "",
                email: "",
              }}
              validationSchema={validationSchema}
            >
              {(formik) => (
                <form
                  onSubmit={formik.handleSubmit}
                  style={{ padding: "10px" }}
                >
                  <div style={{ marginBottom: "30px" }}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="email">Email</InputLabel>
                      <Input
                        name="email"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        id="email"
                        aria-describedby="email-helper-text"
                      />
                      <FormHelperText error={true} id="email-helper-text">
                        {formik.touched.email ? formik.errors.email : null}
                      </FormHelperText>
                    </FormControl>
                  </div>
                  <div style={{ marginBottom: "30px" }}>
                    <FormControl fullWidth={true}>
                      <InputLabel htmlFor="password">Password</InputLabel>
                      <Input
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="password"
                        type="password"
                        id="password"
                        aria-describedby="password-helper-text"
                      />
                      <FormHelperText error={true} id="password-helper-text">
                        {formik.touched.password
                          ? formik.errors.password
                          : null}
                      </FormHelperText>
                    </FormControl>
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      fullWidth={true}
                      disabled={this.props.Authentication.isLoading}
                    >
                      LOGIN
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
          </Card>
        </div>
      </ThemeProvider>
    );
  }
}
const mapStateToProps = (store) => ({
  Authentication: store.Authentication,
});
export default connect(mapStateToProps)(SignIn);
